import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { APIURLConstantsService } from '../services/api-url-service/apiurlconstants.service';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ListUtesService {
  public valFiltres = {};
  public validFilters;
  public currentPage: number = 0;
  public rowsPerPage: number = 20;
  public data_limit_presentacio: number;
  public data_publicacio: number;

  public getSearchValues(id) { return (this.valFiltres[id]?this.valFiltres[id]:""); }

  public getAutocomplete(id: string): Observable<Array<{value: string, text: string}>> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'autocomplete/' + id)
    .pipe(map(response => { return response || []; }));
  }

  constructor(protected authHttp: HttpClient) { }
}
